import React from 'react';
import { Login as SharedLogin } from '@gastrosoft/shared/auth';
import { useBranding } from '../contexts/BrandingContext';
import { authClient } from './authClient';

export default function Login() {
  const { logo, appName } = useBranding();
  return <SharedLogin appTitle={appName} logo={logo} authClient={authClient} />;
}
